import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.33268 5.83333C8.33268 5.3731 8.70578 5 9.16602 5H15.8327C16.2929 5 16.666 5.3731 16.666 5.83333C16.666 6.29357 16.2929 6.66667 15.8327 6.66667H9.16602C8.70578 6.66667 8.33268 6.29357 8.33268 5.83333ZM8.33268 14.1667C8.33268 13.7064 8.70578 13.3333 9.16602 13.3333H15.8327C16.2929 13.3333 16.666 13.7064 16.666 14.1667C16.666 14.6269 16.2929 15 15.8327 15H9.16602C8.70578 15 8.33268 14.6269 8.33268 14.1667ZM6.37406 12.3722C6.76371 12.6171 7.27814 12.4998 7.52306 12.1101C7.76799 11.7205 7.65066 11.2061 7.26101 10.9611L7.05769 10.8333L15.8327 10.8333C16.2929 10.8333 16.666 10.4602 16.666 10C16.666 9.53976 16.2929 9.16667 15.8327 9.16667L7.05769 9.16667L7.26101 9.03886C7.65066 8.79394 7.76799 8.27951 7.52306 7.88986C7.27814 7.5002 6.76371 7.38288 6.37406 7.6278L3.72254 9.29447C3.47992 9.44697 3.33268 9.71343 3.33268 10C3.33268 10.2866 3.47992 10.553 3.72254 10.7055L6.37406 12.3722Z"
      fill={fill}
    />
  </g>
);

export default Icon;
